"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk45FFMD6H_js = require('./chunk-45FFMD6H.js');
var react = require('react');
var l = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var l__default = /*#__PURE__*/_interopDefaultLegacy(l);

var o=l__default["default"].textarea`
  border: none;
  outline: none;
  background-color: transparent;
  border-radius: var(--border-radius-small);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-regular);
  line-height: var(--line-height-regular);
  color: var(--foreground-primary);
  padding: var(--spacing-small) var(--spacing-regular);
  min-height: 40px;

  ::placeholder {
    font-style: italic;
    color: var(--foreground-input-placeholder);
  }
`,g=l.css`
  color: var(--foreground-input-disabled);
  border: var(--border-width-x-small) solid var(--border-input-disabled);
  background: var(--background-input-disabled);
  outline: none;
  cursor: not-allowed;

  ${o} {
    background: var(--background-input-disabled);
    cursor: not-allowed;
  }

  &:hover {
    outline: none;
    border: var(--border-width-x-small) solid var(--border-input-disabled);
  }
`,m=l.css`
  color: var(--color-pink-50);
  border: var(--border-width-x-small) solid var(--border-input-error);

  &:hover {
    border: var(--border-width-x-small) solid var(--border-input-error);
  }

  &:focus-within {
    outline: var(--border-width-small) solid var(--border-input-error-outline);
    border: var(--border-width-x-small) solid var(--border-input-error);
  }
`,h=l.css`
  background-color: var(--background-input-default);
  border: var(--border-width-x-small) solid var(--border-input-read-only);
  outline: none;
`,a=l__default["default"](chunk45FFMD6H_js.d)`
  color: var(--foreground-secondary);
  text-align: right;
  line-height: var(--line-height-regular);
  height: calc(var(--spacing-large) + var(--spacing-x-small));
  padding: var(--spacing-x-small) var(--spacing-regular);
`,x=l.css`
  ${o}, ${a} {
    font-size: var(--font-size-small);
  }
  ${a} {
    padding-top: var(--spacing-small);
  }
`,f=l.css`
  flex-direction: column;
  resize: both;
  overflow: hidden;
  position: relative;
  padding: var(--spacing-small) 0 0;
  min-height: calc(40px + 36px);

  ${o} {
    resize: none;
    padding-top: 0;
    padding-bottom: 0;
    flex: 1;
  }
`,s=l__default["default"].div`
  display: inline-flex;
  overflow: hidden;
  min-height: 40px;
  background-color: var(--background-input-default);
  border: var(--border-width-x-small) solid var(--border-input-default);
  border-radius: var(--border-radius-small);

  &:hover {
    outline: none;
    border: var(--border-width-x-small) solid var(--border-input-hover);
  }

  &:focus-within {
    outline: var(--border-width-small) solid var(--border-input-active-outline);
  }

  ${({$counter:r})=>r&&f}

  ${({$error:r})=>r&&m}
  ${({$readOnly:r})=>r&&h}

  ${({$disabled:r})=>r&&g}
  ${({$size:r})=>r==="small"&&x}
`;var T=react.forwardRef(({counter:r,size:t="regular",error:u=!1,disabled:i=!1,readOnly:d=!1,className:b,...c},v)=>jsxRuntime.jsxs(s,{$error:u,$disabled:i,$readOnly:d,$size:t,$counter:r,className:b,children:[jsxRuntime.jsx(o,{ref:v,disabled:i,readOnly:d,...c}),r&&jsxRuntime.jsx(a,{variant:t==="small"?"200":"100",children:r})]})),A=l__default["default"](T)``;

exports.a = A;
